import React, { RefObject } from 'react';
import styles from './styles.module.css';
import MyPlatesTotal from '@/components/pages/plates/MyPlatesContent/MyPlatesTotal';
import Button from '@/components/common/Button';
import MainIcons from '@/icons/main';
import { Blog } from '@/commonTypes';
import BlogTags from '../BlogTags';
import BlogWriter from '../BlogWriter';

export default function BlogText({
  processedContent,
  contentRef,
  data,
}: {
  processedContent?: string;
  contentRef?: RefObject<HTMLDivElement>;
  data?: Blog;
}) {
  return (
    <div className={`${styles.prose} content-section`} ref={contentRef}>
      <div dangerouslySetInnerHTML={{ __html: processedContent || '' }} />

      <MyPlatesTotal
        d={{
          label: 'نتیجهٔ آنی، پرداخت امن و تخفیف یکجا',
          title: 'همین حالا خلافی خودرو را استعلام کنید',
        }}
        className={`${styles.banner}`}
        showGlow={false}
      >
        <Button
          className={`btn btn-primary squareButton noBoxShadow`}
          type="link"
          href="/service/خلافی-خودرو"
        >
          استعلام خلافی
          <MainIcons.arrowIcon
            fill="#fff"
            className={`rotateIcon-rtl`}
            width="12px"
            height="12px"
          />
        </Button>
      </MyPlatesTotal>
      <div className={`${styles.tagsContainer}`}>
        <span className={`${styles.tagTitle}`}>برچسب‌ها: </span>
        <BlogTags tags={data?.tags} />
      </div>
      {/* <BlogWriter data={data} /> */}
    </div>
  );
}
